import { API_BASE_URL, getUploadedImageUrl } from '../../../../api';
import React, { useEffect, useContext, useState } from 'react';
import { AccountContext } from '../../../../Contexts/main.context';
import emptyCompanyLogo from '../../../../assets/ICONS/EmptyCompany.svg';
import { setButtons } from '../../../../Functions/theFunctions.jsx';

const ManageClients = () => {
     const {
          activeClient,
          updateClientAccounts,
          clientAccounts,
          updateActiveOutlet,
          updateActiveClient,
          updateOriginalID,
          updateActionButtons,
          updateReturnToLastLink,
          userAccounts
     } = useContext(AccountContext);

     const [savingStatus, setSavingStatus] = useState(null);
     const [statusError, setStatusError] = useState('');

     const [searchTerm, setSearchTerm] = useState('');
     const [selectedManager, setSelectedManager] = useState('-');
     const [selectedStatus, setSelectedStatus] = useState('Active');

     const handleSearchChange = (e) => {
          setSearchTerm(e.target.value.toLowerCase());
     };

   useEffect(() => {
     updateReturnToLastLink(null);
   }, []);


     const handleManagerChange = (e) => {
          setSelectedManager(e.target.value);
     };

     const createClient = async () => {
          updateActiveOutlet('CreateClient');
     };

     const filteredClients = clientAccounts
          .filter(client => client.locationID === '0')
          .filter(client => selectedStatus === 'All' ||
               (selectedStatus === 'Inactive' ? client.status !== 'Active' : client.status === selectedStatus))
          .filter(client => {
               if (selectedManager === '-') {
                    return true; // Show all
               } else if (selectedManager === 0) {
                    return !client.accountManager || client.accountManager === 0;
               } else {
                    return String(client.accountManagerID) === selectedManager;
               }
          })
          .filter(client =>
               client.companyName?.toLowerCase().includes(searchTerm) ||
               client.displayName?.toLowerCase().includes(searchTerm) ||
               client.website?.toLowerCase().includes(searchTerm)
          );

     const editThisRecord = (user) => {
          updateActiveOutlet('editCustomer');
          updateReturnToLastLink('Clients');
          updateActiveClient(user);
     };

     const setThisClient = async (user) => {
          const selectedClient = clientAccounts.find(client => String(client.ID) === String(user.ID));
          if (!selectedClient) {
               console.warn("Client not found");
               return;
          }
          const extraLocations = clientAccounts.filter(client => String(client.locationID) === String(user.ID));
          const locationCount = extraLocations.length;
          const citationCount = selectedClient.citationCount;

          updateReturnToLastLink(null);
          updateActiveClient({ ...selectedClient, LocationCount: locationCount });
          updateOriginalID(selectedClient.ID);
          updateActiveOutlet('ViewLocation');

          const buttons = await setButtons('ClientData', locationCount, citationCount);
          updateActionButtons(buttons);
     };

     const toggleClientStatus = async (user) => {
          const status = user.status === 'Active' ? 'Not Active' : 'Active';
          setSavingStatus(user.ID);
          setStatusError('');
          try {
               const response = await fetch(API_BASE_URL + 'data.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ script: 'updateClientStatus', ID: user.ID, status }),
               });
               const data = await response.json();
               if (!response.ok || data.status !== 'success') throw new Error('Save failed');
               updateReturnToLastLink('Clients');
               updateClientAccounts(accounts => accounts.map(client =>
                    String(client.ID) === String(user.ID) ? { ...client, status } : client
               ));
               if (String(activeClient.ID) === String(user.ID)) {
                    updateActiveClient({ ...activeClient, status });
               }
          } catch (error) {
               setStatusError('Unable to save client status. Please try again.');
          } finally {
               setSavingStatus(null);
          }
     };

     return (
          <div className="col-46 offset-1 mt-4 d-flex alert-light flex-wrap gap-3 justify-content-center">
               <div className="w-100 p-3 d-flex flex-wrap gap-3 align-items-center alert-secondary">
                    <div className="d-flex flex-wrap gap-2 align-items-center">
                         <div className="btn btn-warning text-nowrap" onClick={createClient}>Create Client</div>
                         <div>
                              <select
                                   className="form-select"
                                   value={selectedManager}
                                   onChange={handleManagerChange}
                              >
                                   <option value="-">Select Manager</option>
                                   {userAccounts
                                        .filter(user => user.accountSecurity !== 'Client')
                                        .map((manager, index) => (
                                             <option key={index} value={manager.ID}>
                                                  {manager.displayName || 'None'}
                                             </option>
                                        ))}
                                   <option value="0">No Manager</option>
                              </select>
                         </div>
                         <div className="btn-group" role="group" aria-label="Filter clients by status">
                              {['Active', 'Inactive'].map(status => (
                                   <button key={status} type="button"
                                        className={`btn ${selectedStatus === status ? 'btn-primary' : 'btn-outline-primary'}`}
                                        aria-pressed={selectedStatus === status}
                                        onClick={() => setSelectedStatus(status)}>{status}</button>
                              ))}
                         </div>
                         <div>
                              <select
                                   className="form-select"
                                   aria-label="Client status"
                                   value={selectedStatus}
                                   onChange={e => setSelectedStatus(e.target.value)}
                              >
                                   <option value="All">All Statuses</option>
                                   <option value="Active">Active</option>
                                   <option value="Inactive">Inactive</option>
                              </select>
                         </div>
                    </div>

                    <div className="ms-auto d-flex flex-wrap gap-2 align-items-center justify-content-end">
                         <label htmlFor="client-search" className="fw-bold text-navy text-nowrap">Find Client</label>
                         <div>
                              <input
                                   id="client-search"
                                   type="search"
                                   className="form-control"
                                   placeholder="Search clients..."
                                   onChange={handleSearchChange}
                              />
                         </div>
                    </div>
               </div>

               <div className="w-100 text-navy fw-bold">
                    Active Clients: {clientAccounts.filter(client => client.locationID === '0' && client.status === 'Active').length}
               </div>
               {statusError && <div role="alert" className="w-100 alert alert-danger">{statusError}</div>}
               {filteredClients.map((user, index) => (
                    <div className="col-md-10 mb-1" key={index}>
                         <div className="card border-solid border-2 border-secondary p-4">
                              <div className="d-flex justify-content-center">
                                   <img
                                        src={user.logoLink ? getUploadedImageUrl(user.logoLink) : emptyCompanyLogo}
                                        className="card-img-top"
                                        alt={`${user.displayName}'s profile`}
                                        style={{
                                             width: "100%",
                                             height: "100px",
                                             objectFit: "contain",
                                        }}
                                   />
                              </div>
                              <div className="card-body">
                                   <h5 className="card-title text-center fw-bold text-truncate">{user.companyName}</h5>
                                   <div className="text-center fs-7">Phone : {user.phone || 'Not Set'}</div>
                                   <div className="text-center fs-7 pb-2 text-truncate">Website : {user.website || 'Not Set'}</div>
                                   <div className="card-text text-center border-top pt-3 d-flex gap-2 border-navy">
                                        <button type="button" className={`col-15 p-2 user-pill text-light border-0 ${user.status === 'Active' ? 'bg-success' : 'bg-warning'}`} disabled={savingStatus !== null} onClick={() => toggleClientStatus(user)}>
                                             {savingStatus === user.ID ? 'Saving...' : user.status === 'Active' ? 'Deactivate' : 'Activate'}
                                        </button>
                                        <button type="button" className="col-15 p-2 user-pill text-light bg-primary border-0" onClick={() => setThisClient(user)}>Open</button>
                                        <div className="col-15 p-2 user-pill text-light bg-warning" onClick={() => editThisRecord(user)}>Edit</div>
                                   </div>
                              </div>
                         </div>
                    </div>
               ))}
          </div>
     );
};

export default ManageClients;
